export default __webpack_public_path__ + "static/media/Better-Prosthetic.c34c1e58.png";